import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 rounded-full text-sm font-semibold transition-[transform,background-color,color,border-color,box-shadow] duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-300 disabled:pointer-events-none disabled:opacity-50 active:scale-[.98]",
  {
    variants: {
      variant: {
        default: "bg-emerald-300 text-slate-950 hover:bg-emerald-200 shadow-[0_12px_40px_-18px_rgba(191,255,111,.75)]",
        secondary: "bg-white/8 text-white border border-white/12 hover:bg-white/12",
        outline: "border border-slate-300/70 bg-transparent text-slate-900 hover:bg-slate-950 hover:text-white dark:border-white/15 dark:text-white dark:hover:bg-white dark:hover:text-slate-950",
        ghost: "text-current hover:bg-slate-950/5 dark:hover:bg-white/10"
      },
      size: { default: "h-11 px-5", sm: "h-9 px-4 text-xs", lg: "h-13 px-7 text-base", icon: "size-10 p-0" }
    },
    defaultVariants: { variant: "default", size: "default" }
  }
)

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & VariantProps<typeof buttonVariants>

export function Button({ className, variant, size, ...props }: ButtonProps) {
  return <button className={cn(buttonVariants({ variant, size }), className)} {...props} />
}

export { buttonVariants }
